import script from "./FreelanceHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FreelanceHeader.vue?vue&type=script&setup=true&lang=js"

import "./FreelanceHeader.vue?vue&type=style&index=0&id=76702ff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76702ff8"]])

export default __exports__